import React from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmationStep = ({
  activeTab,
  userInfo,
  getCurrentAmount,
  getAutoAjrAmount,
  getTotalAmount,
  handleStartOver,
  scheduleId
}) => {
  const { t } = useTranslation();

  const APP_BASE_URL = window._ENV_?.REACT_APP_BASE_URL || "http://localhost:3000";

  const goToManageDonations = () => {
    window.open(`${APP_BASE_URL}/manage-donation/${scheduleId}`, '_blank');
  }
  return (
    <div className="p-6 text-center">
      <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h2 className="text-2xl font-bold mb-2">{t('autoAjr.thankYou')}</h2>
      <p className="text-gray-600 mb-6">
        {activeTab === 'once'
          ? t('autoAjr.donationProcessedSuccess')
          : t('autoAjr.subscriptionSetupSuccess')}
      </p>
      <div className="bg-gray-50 p-4 rounded-lg mb-6 text-left max-w-md mx-auto">
        <h3 className="text-lg font-semibold mb-2">{t('autoAjr.donationSummary')}</h3>
        <div className="py-2 border-b border-gray-300 flex justify-between">
          <span>{t('autoAjr.name')}</span>
          <span>{userInfo.firstName + " " + userInfo.lastName}</span>
        </div>
        <div className="py-2 border-b border-gray-300 flex justify-between">
          <span>{t('autoAjr.email')}</span>
          <span>{userInfo.email}</span>
        </div>
        <div className="py-2 border-b border-gray-300 flex justify-between">
          <span>{activeTab === 'once' ? t('autoAjr.amount') : t('autoAjr.weeklyAmount')}</span>
          <span>£{getCurrentAmount().toFixed(2)}</span>
        </div>
        <div className="py-2 border-b border-gray-300 flex justify-between">
          <span>{t('autoAjr.autoAjrSupport')}</span>
          <span>£{getAutoAjrAmount().toFixed(2)}</span>
        </div>
        <div className="py-3 flex justify-between font-bold">
          <span>{t('autoAjr.total')}</span>
          <span>£{getTotalAmount().toFixed(2)}</span>
        </div>
      </div>
      <button
        className="py-3 px-6 bg-blue-900 text-white font-bold rounded-lg hover:bg-blue-800 transition"
        onClick={handleStartOver}
      >
        {t('autoAjr.makeAnotherDonation')}
      </button>
      {activeTab === 'weekly' && <button
        style={{ marginLeft: '10px'}}
        className="py-3 px-6 bg-blue-900 text-white font-bold rounded-lg hover:bg-green-800 transition ml-2"
        onClick={goToManageDonations}
      >
        {t('autoAjr.manageDonations')}
      </button>}
    </div>
  );
};

export default ConfirmationStep;